var map = {
	"./ali.jpg": 6860,
	"./arty.jpg": 9789,
	"./bagherra.jpg": 4360,
	"./berlioz_et_figaro.jpg": 2974,
	"./chataigne.jpg": 9237,
	"./elias.jpg": 6695,
	"./evy.jpg": 9664,
	"./fristy.jpg": 3312,
	"./goliath.png": 9520,
	"./lea_et_hermes.png": 3275,
	"./malo.jpg": 4236,
	"./meiko.png": 5410,
	"./nessie.jpg": 1097,
	"./papuche.jpg": 1311,
	"./pelotte.jpg": 7501,
	"./silk.jpg": 7942,
	"./sushi.jpg": 2473,
	"./tayzon.jpg": 6974,
	"./tilly.png": 6220,
	"./twix.png": 1294,
	"./twix_et_galak.png": 498,
	"./ydon_et_chich.jpg": 5077,
	"./zoe.jpg": 3808
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9001;